import { inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Observable, from, mergeMap, of } from 'rxjs';

import { AuthFacade } from '~console/app/~store/facades/auth.facade';
import { ROUTES } from '../constants/routes.constants';
import { UserRole } from '~core/models/auth.models';

export const NON_ADMIN_GUARD = (): Observable<UrlTree | boolean> | boolean => {
  const authFacade = inject(AuthFacade);
  const router = inject(Router);

  return authFacade.currentUser$.pipe(
    mergeMap(currentUser => {
      if (
        currentUser &&
        (currentUser.roles.includes(UserRole.ROLE_SUPER_ADMIN) ||
          currentUser.roles.includes(UserRole.ROLE_ADMIN))
      ) {
        return from(router.navigateByUrl(ROUTES.home));
      }
      return of(true);
    })
  );
};
